"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _togaButton = _interopRequireDefault(require("@thinkific/toga-button"));

var _togaDropdown = require("@thinkific/toga-dropdown");

var _togaIcon = _interopRequireDefault(require("@thinkific/toga-icon"));

var _DropdownToggle = _interopRequireDefault(require("./DropdownToggle.css"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var cx = _bind["default"].bind(_DropdownToggle["default"]); // eslint-disable-line


var DropdownToggle = function DropdownToggle(props) {
  var children = props.children,
      dimensions = props.dimensions,
      hasGhostStyle = props.hasGhostStyle,
      icon = props.icon,
      isDisabled = props.isDisabled,
      open = props.open,
      showCaret = props.showCaret,
      title = props.title,
      toggleMenu = props.toggleMenu,
      iconPullRight = props.iconPullRight,
      className = props.className,
      rest = _objectWithoutProperties(props, ["children", "dimensions", "hasGhostStyle", "icon", "isDisabled", "open", "showCaret", "title", "toggleMenu", "iconPullRight", "className"]);

  var style = null;

  if (dimensions.toggle) {
    style = dimensions.toggle;
  }

  if (children) {
    // Renders a container with the children inside and the caret
    // Storybook example: Dropdown > split button dropdown
    // Note: Not the best option because if you pass
    // children you need to take care of styling

    /* eslint-disable jsx-a11y/no-static-element-interactions,
      jsx-a11y/click-events-have-key-events
    */
    return /*#__PURE__*/_react["default"].createElement("div", {
      "aria-label": "Toggle Menu",
      className: cx('container', {
        focus: open,
        disabled: isDisabled
      }),
      style: style,
      onClick: isDisabled ? null : toggleMenu
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: cx('child-container')
    }, children), open ? /*#__PURE__*/_react["default"].createElement(_togaIcon["default"], {
      name: "caret-fill-up",
      "aria-hidden": true
    }) : /*#__PURE__*/_react["default"].createElement(_togaIcon["default"], {
      name: "caret-fill-down",
      "aria-hidden": true
    }));
  }

  var toggleClasses = [];

  if (icon && !showCaret && !title) {
    // Renders a perfect square
    // Storybook example: Dropdown > with icon
    toggleClasses = ['button-icon'];
  } else if (icon && title) {
    // Renders a button with font-size: 16px (like Input) with an icon and a caret
    // Storybook example: Select > main example
    toggleClasses = ['button-input', 'button-icon-text', 'button--icon-both'];
  } else if (icon && showCaret) {
    // Renders a button with an icon and a caret
    // Storybook example: MultiSelect > with icon
    toggleClasses = ['button-icon-caret', 'button--icon-both'];
  } else {
    // Renders a button with a title and a caret
    // Storybook example: Dropdown > interactive example
    toggleClasses = ['button-icon-text', 'button-icon-text-right'];
  }

  if (!hasGhostStyle) {
    // Add button-default class, which makes the Toggle looks like a Button
    toggleClasses = ['button-default'].concat(_toConsumableArray(toggleClasses));
  }

  if (className) {
    var classNameProp = Array.isArray(className) ? className : [className];
    toggleClasses = [].concat(_toConsumableArray(toggleClasses), _toConsumableArray(classNameProp));
  } // Render a button with a title and an icon on the right of the button
  // Storybook example: Dropdown > with icon on the right, title and no caret


  if (iconPullRight) {
    toggleClasses = [].concat(_toConsumableArray(toggleClasses), ['button--icon-right']);
  }

  return /*#__PURE__*/_react["default"].createElement(_togaButton["default"], _extends({
    "aria-label": "Toggle Menu",
    className: toggleClasses,
    disabled: isDisabled,
    style: style,
    tabIndex: 0,
    onClick: isDisabled ? null : toggleMenu
  }, rest), icon && !iconPullRight && /*#__PURE__*/_react["default"].createElement(_togaIcon["default"], {
    name: icon,
    "aria-hidden": true
  }), title && /*#__PURE__*/_react["default"].createElement("span", null, title), icon && iconPullRight && /*#__PURE__*/_react["default"].createElement(_togaIcon["default"], {
    name: icon,
    "aria-hidden": true
  }), showCaret && (open ? /*#__PURE__*/_react["default"].createElement(_togaIcon["default"], {
    name: "caret-fill-up",
    "aria-hidden": true
  }) : /*#__PURE__*/_react["default"].createElement(_togaIcon["default"], {
    name: "caret-fill-down",
    "aria-hidden": true
  })));
};

DropdownToggle.displayName = 'DropdownToggle';
DropdownToggle.propTypes = {
  /** HTML Node - it will overide and icon or title property */
  children: _propTypes["default"].node,

  /** extra button classes * */
  className: _propTypes["default"].oneOfType([_propTypes["default"].array, _propTypes["default"].string]),

  /** Object with maxWidth, minWidth and width * */
  dimensions: _propTypes["default"].object,

  /** Use to switch the button-default class with button-ghost */
  hasGhostStyle: _propTypes["default"].bool,

  /** Use icon to render an icon with or without a title. It doesn't play with children */
  icon: _propTypes["default"].string,

  /** specifies where in the button the icon should be* */
  iconPullRight: _propTypes["default"].bool,
  // eslint-disable-line react/boolean-prop-naming

  /** disables the toggle click and adds opacity to the element * */
  isDisabled: _propTypes["default"].bool,
  // eslint-disable-line react/boolean-prop-naming

  /** Flag to control if the dropdown menu is open or closed */
  open: _propTypes["default"].bool,
  // eslint-disable-line react/boolean-prop-naming

  /** Flag to control if the caret will appear */
  showCaret: _propTypes["default"].bool,
  // eslint-disable-line react/boolean-prop-naming

  /** Dropdown title - use this or icon or children */
  title: _propTypes["default"].string,

  /** Function to show/hide the menu */
  toggleMenu: _propTypes["default"].func
};
DropdownToggle.defaultProps = {
  children: null,
  dimensions: _togaDropdown.Dropdown.defaultProps.dimensions,
  hasGhostStyle: false,
  open: false,
  title: '',
  toggleMenu: function toggleMenu() {},
  showCaret: true,
  icon: null,
  iconPullRight: false,
  isDisabled: false,
  className: null
};
var _default = DropdownToggle;
exports["default"] = _default;